import {
  createTheme,
  PaletteOptions,
  Theme,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { unifiedLightPageShadows } from '../unified-theme/light/unifiedLightPageShadows';
import { lightPalette } from '../palette/light';
import { darkPalette } from '../palette/dark';
import { unifiedDarkPageShadows } from '../unified-theme/dark/unifiedDarkPageShadows';

/**
 * Creates a MUI theme based on the provided palette configuration.
 *
 * @param {PaletteOptions} palette - The palette configuration for the theme.
 *
 * @returns {Theme} The MUI theme object.
 *
 * @category Theming
 */
const muiTheme = (palette: PaletteOptions, pageShadows: string[]): Theme =>
  createTheme({
    palette: palette,
    typography: {
      fontFamily: 'Rubik',
      fontSize: 14,
    },
    shape: {
      borderRadius: 12,
    },
    shadows: [...pageShadows, 'none'] as Theme['shadows'],
  });

/**
 * The `muiLightTheme` object is a MUI theme object that uses the light palette configuration.
 *
 * @category Theming
 */
export const muiLightTheme = muiTheme(lightPalette, unifiedLightPageShadows);

/**
 * The `muiDarkTheme` object is a MUI theme object that uses the dark palette configuration.
 *
 * @category Theming
 */
export const muiDarkTheme = muiTheme(darkPalette, unifiedDarkPageShadows);
